(function () {
  "use strict";

  /**
   * @module servicesSearchFacets
   */
  var servicesSearchFacets = {};

  /**
   * Initialise Services Search Form functionality
   *
   * @memberof module:servicesSearchFacets
   */
  servicesSearchFacets.init = function () {
    var $expandAllFacets = $(".qld__service_search__facets__expand-all");
    var allExpanded = false;
    var $facetBtns = $(".qld__service_search__facets .js-qld__accordion");

    $expandAllFacets.on("click", () => {
      let $accordions = $expandAllFacets
        .closest(".qld__accordion__body")
        .find(".js-qld__accordion");

      if (!allExpanded) {
        $accordions.each(function () {
          let $this = $(this);

          $this
            .removeClass("qld__accordion--closed")
            .addClass("qld__accordion--open");
          $this
            .next()
            .removeClass("qld__accordion--closed")
            .addClass("qld__accordion--open");
        });

        $expandAllFacets.text("Collapse all");
        allExpanded = true;
      } else {
        $accordions.each(function () {
          let $this = $(this);

          $this
            .removeClass("qld__accordion--open")
            .addClass("qld__accordion--closed");
          $this
            .next()
            .removeClass("qld__accordion--open")
            .addClass("qld__accordion--closed");
        });

        $expandAllFacets.text("Expand all");
        allExpanded = false;
      }
    });

    $facetBtns.on("click", () => {
      setTimeout(function () {
        let expandedCounter = 0;

        $facetBtns.each(function () {
          if ($(this).hasClass("qld__accordion--open")) {
            expandedCounter++;
          }
        });

        if (expandedCounter > 0) {
          $expandAllFacets.text("Collapse all");
          allExpanded = true;
        } else if (expandedCounter === 0) {
          $expandAllFacets.text("Expand all");
          allExpanded = false;
        }
      }, 50);
    });

    let sfUrl = $("#DATA_HOLDER").data("sfurl");
    let serviceCategoriesUrl = `${sfUrl}/service-categories`;

    if (sfUrl) {
      $.get(serviceCategoriesUrl, function (data) {
        let serviceCats = data;

        $(".qld__service_search__facets__section__item li a").each(function () {
          let $this = $(this);

          for (let i = 0; i < serviceCats.length; i++) {
            if (serviceCats[i].id === $this.text()) {
              $this.text(serviceCats[i].name);
            }
          }
        });
      });
    }
  };

  QLD.servicesSearchFacets = servicesSearchFacets;

  document.addEventListener("DOMContentLoaded", QLD.servicesSearchFacets.init);
})();
